"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _ReportBlockTradeSidePaneComponent = _interopRequireDefault(require("./ReportBlockTradeSidePaneComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;
  return {
    form: form.reportBlockTrade
  };
};
var mapDispatchToProps = {
  setBoughtReport: function setBoughtReport() {
    return (0, _reduxForm.change)('reportBlockTrade', 'side', _orderEntryFormConstants.buyValue);
  },
  setSoldReport: function setSoldReport() {
    return (0, _reduxForm.change)('reportBlockTrade', 'side', _orderEntryFormConstants.sellValue);
  },
  clearReportBlockTrade: function clearReportBlockTrade() {
    return (0, _orderEntryActions.clearOrderForm)('reportBlockTrade');
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ReportBlockTradeSidePaneComponent["default"]);